export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-background-50">青青草视频</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                青青草视频汇聚妖精视频、桃花视频、苹果视频、榴莲视频等多家特色平台，
                打造一站式影视大全与热门视频合集，每日精选更新海量高清视频内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="space-y-2.5">
                {[
                  { label: '精选推荐', href: '#media' },
                  { label: '视频索引', href: '#index' },
                  { label: '热门榜单', href: '#ranking' },
                  { label: '精彩推荐', href: '#cards' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门话题</h4>
              <div className="flex flex-wrap gap-2">
                {['影视大全', '热门视频', '视频合集', '妖精视频', '桃花视频', '苹果视频', '榴莲视频', '豆花视频'].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 text-xs rounded-full bg-foreground-800 text-background-300 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                与多家优质视频平台保持合作关系，持续拓展内容生态。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 青青草视频 - 影视大全与热门视频合集平台。本站内容仅供展示。
            </p>
            <div className="flex items-center gap-5">
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}